import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { handleMouseMove } from '../constants/ButtonHover';
export const Button = ({ label, type = 'button', onClick, disabled = false, variant = 'primary', className = '', }) => {
    const handleClick = (e) => {
        const button = e.currentTarget;
        const circle = document.createElement('span');
        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        circle.style.width = circle.style.height = `${size}px`;
        circle.style.left = `${x}px`;
        circle.style.top = `${y}px`;
        circle.className = 'ripple';
        button.appendChild(circle);
        setTimeout(() => circle.remove(), 600);
        if (onClick)
            onClick(e);
    };
    return (_jsx("button", Object.assign({ type: type, onClick: (e) => {
            handleClick(e);
        }, disabled: disabled, className: `button ${variant}-btn ${disabled ? 'disabled' : ''} ${className}`, onMouseMove: handleMouseMove }, { children: _jsxs("span", { children: [" ", label] }) })));
};
